import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { containerIcon } from '../helpers'
import React from 'react'

const ContainerBalance = props => {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      container
      alignItems="center"
      className={props.classes.container}
    >
      <Grid item xs={4} align="center">
        <img alt={'Imagen'} src={containerIcon(props.data.containerIconFileName)} className={props.classes.containerIcon} />
      </Grid>
      <Grid item xs={8}>
        <Grid container direction="column" className={props.classes.body}>
          <Grid item style={{ marginBottom: -6 }}>
            <Typography className={props.classes.containerName}>{props.data.containerName}</Typography>
          </Grid>
          {props.data.balances.length == 1 && (
            <Grid item>
              <Typography className={props.classes.balance + (props.data.balances[0].balance > 0 ? ' ' + props.classes.balanceWarning : '')}>
                {props.data.balances[0].balance.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              </Typography>
            </Grid>
          )}
          {props.data.balances.length > 1 && (
            <Grid item>
              <table className={props.classes.farmerBalancesTable}>
                {props.data.balances.map(balance => (
                  <tr>
                    <td className={props.classes.farmerBalanceName + (balance.balance > 0 ? ' ' + props.classes.farmerBalanceWarning : '')}>
                      {balance.mainFarmerName}
                    </td>
                    <td className={props.classes.farmerBalanceValue + (balance.balance > 0 ? ' ' + props.classes.farmerBalanceWarning : '')}>
                      {balance.balance.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                    </td>
                  </tr>
                ))}
              </table>
            </Grid>
          )}
          <Grid item>
            <span>
              <Typography className={props.classes.stock}>
                { props.data.stock.toLocaleString(undefined, { maximumFractionDigits: 2 }) } disponibles
              </Typography>
            </span>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const styles = {
  container: {
    padding: '5px 0',
    borderRight: '1px solid #BBB',
    borderBottom: '1px solid #BBB',
    //cursor: 'pointer',
  },
  containerIcon: {
    width: '80%',
    maxWidth: 120,
  },
  body: {
    paddingRight: 10,
  },
  containerName: {
    fontSize: 16,
    fontWeight: 500,
    color: '#1B458E',
  },
  balance: {
    fontWeight: 'bold',
    fontSize: 30,
  },
  balanceWarning: {
    color: 'red',
  },
  farmerBalancesTable: {
    width: '100%',
    margin: '10px 0',
  },
  farmerBalanceName: {
    background: '#eee',
    fontSize: 12,
    padding: 5,
  },
  farmerBalanceValue: {
    background: '#eee',
    fontSize: 12,
    padding: 5,
  },
  farmerBalanceWarning: {
    background: '#f9c4c1',
    fontWeight: 'bold',
  },
  farmerBalance: {
    display: 'inline-block',
    border: '1px solid black',
    borderRadius: 5,
    padding: '1px 5px',
  },
  stock: {
    //border: '1px solid black',
    fontSize: 16,
    fontWeight: 500,
    //borderRadius: 5,
    //padding: '1px 5px',
    margin: '5px 0',
  },
}

export default withStyles(styles)(ContainerBalance)



// WEBPACK FOOTER //
// ./src/components/ContainerBalance.js